// extracted by mini-css-extract-plugin
export default {"charts":"SystemLoadChartContainer_charts__IklE0","chart":"SystemLoadChartContainer_chart__wYfe4"};